import React, { useState } from 'react';
import Autosuggest from 'react-autosuggest';

export default function AutosuggestInput({
  items,
  value,
  onChange,
  onSelect,
  placeholder
}) {
  const [suggestions, setSuggestions] = useState([]);

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={v => 
        setSuggestions(items)
      }
      onSuggestionsClearRequested={() =>
        setSuggestions([])
      }
      getSuggestionValue={s => s}
      renderSuggestion={s => <span>{s}</span>}
      onSuggestionSelected={(_e, { suggestion }) =>
        onSelect(suggestion)
      }
      inputProps={{
        placeholder: placeholder,
        value: value,
        onChange: (_e, { newValue }) => onChange(newValue)
      }}
      shouldRenderSuggestions={() => true}
    />
  );
}
